import {Loader, showMessages, showAlert} from './dom_utils';

export async function post(data, params = {}) {
    // @data data{object}	    // URLSearch ou formData ou simple object
    // Doit au minimum contenir data.a{string} (a = action)
    // @param params{object}	    // auth default true, err_msg default {}, silent default false, loader default true, msg_success default undefined sinon clef (voir post.msg.success) ou string, show_alert_success {undefined|true} showAlert() plutôt que showMessages(), return_all{true|undefined) retourner tout le json
    // Note: le retour serveur json.type n'est actuellement pas utilisé
    if(typeof params.auth === 'undefined') params.auth = true;
    if(typeof params.err_msg === 'undefined') params.err_msg = {};
    if(typeof params.silent === 'undefined') params.silent = false;		    // global, et succès et erreur
    if(typeof params.loader === 'undefined') params.loader = true;
    if(typeof params.msg_success === 'undefined') params.msg_success = null;	    // "silent" = silencieux (que si succès) (utilisation avec return_all)
    if(typeof params.show_alert_success === 'undefined') params.show_alert_success = false;
    if(typeof params.return_all === 'undefined') params.return_all = false;	    // usage rare, utile lorsque serveur retourne data différente

    const spin = params.loader ? new Loader().show() : null;

    // Priorité à un message provenant du serveur
    let msg = null;	// Si défini en bas => showMessages()

    try {
	data = new URLSearchParams(data);


	const response = await fetch(params.auth ? 'php/ajax_auth.php' : 'php/ajax.php', {
	    method: 'POST',
	    body: data,
	    signal: AbortSignal.timeout(10000),
	    headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	    }
	});
	if(!response.ok) {	// Allow only the 200 range
	    throw new Error(`Response status: ${response.status}`);
	}
	const content_type = response.headers.get('content-type');
	if(!content_type || !content_type.includes('application/json')) {
	    throw new TypeError('Response not JSON');
	}

	const json = await response.json();


	if(json.response === 'success') {
	    if(params.msg_success !== 'silent') {
		if(json.msg) msg = json.msg;
		else if(params.msg_success) {
		    if(typeof post.msg.success[params.msg_success] !== 'undefined') msg = post.msg.success[params.msg_success];
		    else msg = params.msg_success;
		}
	    }
	    return params.return_all ? json : json.data;
	} else {
	    if(json.msg) msg = json.msg;
	    throw json.data;
	}

    } catch(err) {
	params.show_alert_success = false;	    // Que pour les succès
	let ret, append_log = '';
	if(typeof err === 'string') {
	    ret = err;
	    if(msg === null) {
		if (params.err_msg[err]) msg = params.err_msg[err];
		else switch(err) {
		    case 'auth': msg = "Une erreur d'authenfication s'est produite"; break;
		    case 'param': msg = "Une erreur de paramètres s'est produite"; break;
		    case 'db': msg = "Une erreur base de données s'est produite"; break;
		    case '':
		    default: msg = "Une erreur s'est produite"; break;
		}
	    }
	} else {
	    switch(err.name) {
		case 'TimeoutError':
		    ret = 'timeout';
		    msg = msg || "Une erreur timeout s'est produite, veuillez vérifier votre connexion et réessayer";
		    break;
		case 'AbortError':
		    ret = 'user_action';
		    append_log = 'Canceled by user action (browser stop button, closing tab, etc.)';
		    break;
		default:
		    ret = 'ajax';
		    append_log = `type: ${err.name}, message: ${err.message}`;
		    msg = msg || "Une erreur réseau s'est produite, veuillez réessayer.<br>Si l'erreur persite, veuillez nous contacter.";
	    }
	}
	console.log('ajax.post("' + (data.a || data.get('a')) + '"):ERROR:', msg, ret, append_log);

	throw ret;

    } finally {
	if(spin) spin.hide();
	if(params.silent) console.log('ajax.post():INFO: Message non affiché car param.silent = true: ', msg);
	else if(msg !== null) {
	    if(params.show_alert_success) {
		showAlert('success', msg, 'scroll');
	    } else {
		showMessages(msg);
	    }
	}
    }
};
post.msg = {
    success: {
	updated: 'Mise à jour avec succès',
	silent: null		// Dummy key, never read
    }
};

// API fetch pas prête pour le suivi de l'upload, on utilise xhr
// https://stackoverflow.com/questions/35711724/upload-progress-indicators-for-fetch
export async function postProgress(form_data, progress_bar, params = {}) {
    if(typeof params.auth === 'undefined') params.auth = true;

    const spin = new Loader().show();

    let msg = null;

    try {
	progress_bar.style.width = '0';

	const xhr = new XMLHttpRequest();
	const response = await new Promise((resolve, reject) => {
	    xhr.upload.addEventListener("progress", e => {
		if(e.lengthComputable) {
		    progress_bar.style.width = Math.round(100 * e.loaded / e.total) + '%';
		}
	    });
	    // Si on veut suivre un download:
	    //xhr.addEventListener("progress", e => {
		//if(e.lengthComputable) {
		    //console.log("download progress:", e.loaded / e.total);
		    //downloadProgress.value = e.loaded / e.total;
		//}
	    //});
	    xhr.addEventListener("error", e => {
		console.log('ajax::postProgress():ERROR', e);
		msg = "Une erreur ajax s'est produite";
		reject('error');
	    });
	    xhr.addEventListener("abort", e => {
		console.log('ajax::postProgress():ABORT', e);
		//msg = "Une erreur ajax s'est produite";	// Abort est du à l'utilisateur (comme reload page), pas de message
		reject('abort');
	    });
	    xhr.addEventListener("timeout", e => {
		console.log('ajax::postProgress():TIMEOUT', e);
		msg = "Une erreur timeout s'est produite";
		reject('timeout');
	    });
	    xhr.addEventListener("load", e => {
		let response;
		try {
		    response = JSON.parse(xhr.response);
		    if(response.response === 'success') {
			resolve(response.data);
			msg = response.msg || 'Action effectuée avec succès';
		    } else {
			if(response.msg) msg = response.msg;
			else switch(response.data) {
			    case 'auth': msg = "Une erreur d'authenfication s'est produite"; break;
			    case 'param': msg = "Une erreur de paramètres s'est produite"; break;
			    case 'db': msg = "Une erreur base de données s'est produite"; break;
			    case '':
			    default: msg = "Une erreur s'est produite"; break;
			}
			reject(response.data);
		    }

		} catch(e) {
		    msg = xhr.responseText;
		    reject('ajax');
		}

	    });
	    xhr.open("POST", params.auth ? 'php/ajax_auth.php' : 'php/ajax.php', true);
	    //xhr.responseType = 'json';
	    xhr.timeout = 20000;
	    xhr.send(form_data);
	});
	return response;
    } catch(err) {
	console.log('ajax.postProgress("' + form_data.get('a') + '"):ERROR:', err);
	throw err;
    } finally {
	spin.hide();
	if(msg !== null) showMessages(msg, params.persistent || false);
    }
}
